import React from 'react'
import { Link } from 'react-router-dom'
import styles from "./menuItemsList.module.css"

function DropdownCard({url,title,img}) {

  const imgStyle={
    width:"150px",
    height:"100px",
    objectFit:"contain",
    overflow:"hidden"
  }
  return (
    <Link to={url} style={{backgroundColor:"rgb(4, 132, 190)"}}>
        <div style={imgStyle}>
            <img src={img} className={styles.cardImg} alt=""/>
        </div>
        <div className='p-1' >
            <span className='fw-bold '>
              {title}
            </span>
        </div>
    </Link>
  )
}

export default DropdownCard